module.exports = __webpack_public_path__ + "img/skillset-gem-2.d0597b49.png";